// extracted by mini-css-extract-plugin
module.exports = {"Item":"collapse_Item__owNUW","Button":"collapse_Button__mndif","Title":"collapse_Title__vGkRk","Content":"collapse_Content__hCgJJ"};